import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Sobre from "./pages/Sobre";
import Blog from "./pages/Blog";
import BlogPost1 from "./pages/BlogPost1";
import BlogPost2 from "./pages/BlogPost2";
import BlogPost3 from "./pages/BlogPost3";
import BlogPost4 from "./pages/BlogPost4";
import BlogPost5 from "./pages/BlogPost5";
import BlogPost6 from "./pages/BlogPost6";
import BlogPost7 from "./pages/BlogPost7";
import BlogPost8 from "./pages/BlogPost8";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import SoftwareDevelopment from "./pages/SoftwareDevelopment";
import ProcessAutomation from "./pages/ProcessAutomation";
import SecurityServices from "./pages/SecurityServices";
import ITConsulting from "./pages/ITConsulting";
import Contact from "./pages/Contact";
import ClientPortal from "./pages/ClientPortal";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";
import ClientLayout from "./components/ClientLayout";
import ClientDashboard from "./pages/ClientDashboardSimple";
import ClientDashboardPortal from "./pages/ClientDashboardPortal";
import DashboardRouter from "./pages/DashboardRouter";
import ClientTickets from "./pages/ClientTickets";
import ClientTicketNew from "./pages/ClientTicketNew";
import ClientTicketDetail from "./pages/ClientTicketDetailNew";
import ClientFaturas from "./pages/ClientFaturas";
import ClientPropostas from "./pages/ClientPropostas";
import ClientContratos from "./pages/ClientContratos";
import AdminTicketsPage from "./pages/AdminTickets";
import AdminFaturas from "./pages/AdminFaturas";
import ProtectedRoute from "./components/ProtectedRoute";
import WebsiteAEO from "./pages/WebsiteAEO";
import DiagnosticoGratuito from "./pages/DiagnosticoGratuito";

import Relatorio from "./pages/Relatorio";
import DiagnosticoCompleto from "./pages/DiagnosticoCompleto";
import Orcamento from "./pages/Orcamento";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";

// Admin Components (now inside client portal)
import { UserManagement } from "./pages/AdminDashboard/components/UserManagement";
import { ClientManagement } from "./pages/AdminDashboard/components/ClientManagement";

const queryClient = new QueryClient();

const App = () => {
  console.log("🔵 App.tsx renderizado!");
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/tendencias-desenvolvimento-web-2026" element={<BlogPost1 />} />
            <Route path="/blog/automacao-transformar-negocio" element={<BlogPost2 />} />
            <Route path="/blog/seguranca-digital-proteja-dados" element={<BlogPost3 />} />
            <Route path="/blog/ia-generativa-revoluciona-desenvolvimento" element={<BlogPost4 />} />
            <Route path="/blog/chatgpt-o1-raciocinio-avancado" element={<BlogPost5 />} />
            <Route path="/blog/gemini-2-google-multimodal" element={<BlogPost6 />} />
            <Route path="/blog/ia-codigo-aberto-llama-mistral" element={<BlogPost7 />} />
            <Route path="/blog/agentes-ia-autonomos-futuro" element={<BlogPost8 />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/desenvolvimento-software" element={<SoftwareDevelopment />} />
            <Route path="/automacao-processos" element={<ProcessAutomation />} />
            <Route path="/seguranca-digital" element={<SecurityServices />} />
            <Route path="/consultoria-ti" element={<ITConsulting />} />
            <Route path="/desenvolvimento-sites-aeo" element={<WebsiteAEO />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/diagnostico-gratuito" element={<DiagnosticoGratuito />} />
            <Route path="/relatorio/:id" element={<Relatorio />} />
            <Route path="/diagnostico-completo" element={<DiagnosticoCompleto />} />
            <Route path="/orcamento" element={<Orcamento />} />
            <Route path="/checkout/:planId" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/area-cliente" element={<ClientPortal />} />
            <Route path="/esqueci-senha" element={<ForgotPassword />} />
            <Route path="/redefinir-senha" element={<ResetPassword />} />

            {/* Client Portal Routes - Single entry point for all users */}
            <Route
              path="/cliente"
              element={
                <ProtectedRoute>
                  <ClientLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<DashboardRouter />} />
              <Route path="tickets" element={<ClientTickets />} />
              <Route path="tickets/novo" element={<ClientTicketNew />} />
              <Route path="tickets/:id" element={<ClientTicketDetail />} />
              <Route
                path="admin/usuarios"
                element={
                  <ProtectedRoute requireAdmin>
                    <UserManagement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/clientes"
                element={
                  <ProtectedRoute requireAdmin>
                    <ClientManagement />
                  </ProtectedRoute>
                }
              />
            {/* Admin Tickets Route - Inside client layout */}
            <Route
              path="admin/tickets"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminTicketsPage />
                </ProtectedRoute>
              }
            />
            {/* Admin Faturas Route */}
            <Route
              path="admin/faturas"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminFaturas />
                </ProtectedRoute>
              }
            />
            {/* Client Faturas Route */}
            <Route path="faturas" element={<ClientFaturas />} />
            {/* Client Propostas Route */}
            <Route path="propostas" element={<ClientPropostas />} />
            {/* Client Contratos Route */}
            <Route path="contratos" element={<ClientContratos />} />
            </Route>

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
